export enum StateStatus {
    PENDING,
    FULFILLED,
    REJECTED,
}
